import type {
  ReactNode,
} from 'react'

import {
  FieldError as AriaFieldError,
  Label as AriaLabel,
  Text,
  type ValidationResult,
} from 'react-aria-components'

import { cn } from '@/shared/lib/cn'

export type FormFieldErrorMessage =
  | string
  | ((
      validation: ValidationResult,
    ) => string)

export interface FormFieldProps {
  label: ReactNode
  children: ReactNode

  description?: ReactNode
  errorMessage?: FormFieldErrorMessage

  isRequired?: boolean

  labelClassName?: string
  descriptionClassName?: string
  errorClassName?: string
}

export function FormField({
  label,
  children,
  description,
  errorMessage,
  isRequired = false,
  labelClassName,
  descriptionClassName,
  errorClassName,
}: FormFieldProps) {
  return (
    <>
      <AriaLabel
        className={cn(
          [
            'flex items-center gap-1',
            'text-sm font-medium',
            'text-(--color-foreground)',
          ],
          labelClassName,
        )}
      >
        <span>{label}</span>

        {isRequired ? (
          <span
            aria-hidden="true"
            className="text-(--color-danger)"
          >
            *
          </span>
        ) : null}
      </AriaLabel>

      {children}

      {description ? (
        <Text
          slot="description"
          className={cn(
            [
              'text-xs leading-5',
              'text-(--color-muted-foreground)',
            ],
            descriptionClassName,
          )}
        >
          {description}
        </Text>
      ) : null}

      <AriaFieldError
        className={cn(
          [
            'text-xs leading-5',
            'text-(--color-danger)',
          ],
          errorClassName,
        )}
      >
        {errorMessage}
      </AriaFieldError>
    </>
  )
}